import React, { useState, useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import DashboardCommandCenter from "../../components/themeFiles/DashboardCommandCenter";
import { useUserWithCompany } from "../../hooks/useCompany";
import DashboardService from "../../services/DashboardService";
import CompanyConfigurationServices from "../../services/CompanyConfigurationService";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const { companyId } = useUserWithCompany();
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [modulesLoading, setModulesLoading] = useState(true);
  const [companyModules, setCompanyModules] = useState({
    POS: true,
    Kitchen: true,
  });
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();

  // Kitchen staff should only access KDS
  useEffect(() => {
    if (
      !modulesLoading &&
      user?.type === "kitchen_staff" &&
      companyModules.Kitchen
    ) {
      navigate("/kds", { replace: true });
    }
  }, [companyModules.Kitchen, modulesLoading, navigate, user]);

  useEffect(() => {
    const fetchCompanyModules = async () => {
      if (!companyId) {
        setModulesLoading(false);
        return;
      }

      try {
        setModulesLoading(true);
        const response = await CompanyConfigurationServices.getConfigurations(
          companyId,
          "compnay_modules"
        );

        if (!response?.success) return;

        const items =
          response?.data?.view?.data ??
          response?.data?.view?.items ??
          response?.data?.items ??
          [];

        if (items.length > 0) {
          const value = items[0]?.value || {};
          setCompanyModules({
            POS: value.POS !== false,
            Kitchen: value.Kitchen !== false,
          });
        }
      } catch (error) {
        console.error("Error fetching company modules for dashboard:", error);
      } finally {
        setModulesLoading(false);
      }
    };

    fetchCompanyModules();
  }, [companyId]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const response = await DashboardService.getDashboardStats(companyId);

        setDashboardData(response?.data?.view);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
        toast.error("Failed to load dashboard data");
      } finally {
        setLoading(false);
      }
    };

    if (companyId) {
      fetchDashboardData();
    }
  }, [companyId]);

  if (loading || modulesLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  return <DashboardCommandCenter data={dashboardData} />;
};

export default Dashboard;
